import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { PaymentMethod, PaymentServiceProvider } from '@grandvisionhq/payments';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { resetExpressCheckout } from '../../../../StepShipping/actions.js';
import { getShippingDetails } from '../../../../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import '../../../../context/CheckoutSettings/context.js';
import { getChangedOptIns } from '../../../../selectors.js';
import { useSetCustomerDetails } from '../../../../hooks/operations/use-set-customer-details.js';
import '@grandvisionhq/lib-utils-cart';
import { ApplePaySessionErrors } from '../../../../mappers/errors-mapping.js';
import '../../../../operations/mutations/set-customer-details.js';
import '../../../../operations/mutations/set-shipping-method.js';
import '../../../../operations/mutations/set-shipping-state.js';
import '../../../../operations/mutations/set-store.js';
import '../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../operations/mutations/recreate-ordered-checkout.js';
import { getSelectedOptIns } from '../../../../utils/get-selected-opt-ins.js';
import 'lodash/isEmpty';
import '../../../../utils/get-customer-details-payload.js';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import 'history';
import '../../../../utils/has-cart-errors.js';
import { useCreateOrder } from '../../../../hooks/orders/use-create-order.js';
import { useCreateOrderDraft } from '../../../../hooks/orders/use-create-order-draft.js';
import '@grandvisionhq/frk-routing';
import { useRedirectToOrderComplete } from '../../../../hooks/orders/use-redirect-to-order-confirm-page.js';
import '../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../operations/fragments/paypal-payment.js';
import '../../../../operations/fragments/saved-user-details.js';
import '../../../../operations/queries/get-checkout-state.js';
import '../../../../operations/queries/get-user-details.js';
import { useCreateApplePaySession } from './helper-hooks/use-create-apple-pay-session.js';
import { useCreatePaymentRequest } from './helper-hooks/use-create-payment-request.js';
import { mapApplePayContactAddress } from './mappers/apple-pay-contact-address.js';
import { getDateOfBirth } from './mappers/apple-pay-date-of-birth.js';
import { useMapShippingAddress } from './utility-hooks/use-map-shipping-address.js';
import { useValidatePaymentData } from './utility-hooks/use-validate-payment-data.js';
import { useValidateShippingData } from './utility-hooks/use-validate-shipping-data.js';

var UseApplePayError;
(function(UseApplePayError) {
    UseApplePayError["UNSUPPORTED"] = "UNSUPPORTED";
    UseApplePayError["CANCELLED"] = "CANCELLED";
    UseApplePayError["FAILED"] = "FAILED";
})(UseApplePayError || (UseApplePayError = {}));
const useApplePay = ({ returnPath , isExpressPayment =true  } = {})=>{
    const { createApplePaySession , isLoading: createApplePaySessionIsLoading , updateError: createApplePaySessionError ,  } = useCreateApplePaySession();
    const redirectToOrderComplete = useRedirectToOrderComplete();
    const [error, setError] = React.useState();
    const shippingDetails = useSelector(getShippingDetails);
    const changedOptIns = useSelector(getChangedOptIns);
    const mapShippingAddress = useMapShippingAddress();
    const dispatch = useDispatch();
    const validatePaymentData = useValidatePaymentData();
    const validateShippingData = useValidateShippingData();
    const createOrderDraft = useCreateOrderDraft();
    var _isEnabled;
    const isExpressCheckout = (_isEnabled = shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout.isEnabled) !== null && _isEnabled !== void 0 ? _isEnabled : false;
    const [createPaymentRequest, { error: paymentRequestError , loading: paymentRequestLoading  }] = useCreatePaymentRequest(isExpressPayment);
    const [createOrder, { error: createOrderError , loading: createOrderLoading  }] = useCreateOrder({
        returnPath
    });
    const { setCustomerDetails  } = useSetCustomerDetails();
    const payCartWithApplePay = React.useCallback(()=>{
        if (typeof ApplePaySession === 'undefined' && error !== UseApplePayError.UNSUPPORTED) {
            console.error('Apple pay can only be used on Safari.');
            setError(UseApplePayError.UNSUPPORTED);
            toast.failed(ApplePaySessionErrors.ApplePaySessionUnsupported);
            return;
        }
        const paymentRequest = createPaymentRequest();
        if (!paymentRequest) {
            return;
        }
        const session = new ApplePaySession(12, paymentRequest);
        session.onvalidatemerchant = ()=>{
            createApplePaySession(session);
        };
        session.onshippingcontactselected = (e)=>{
            if (!validateShippingData(e, session, paymentRequest)) {
                return;
            }
            session.completeShippingContactSelection({
                newTotal: paymentRequest.total
            });
            return;
        };
        session.onpaymentauthorized = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(e) {
                if (isExpressCheckout && !validatePaymentData(e, session)) {
                    return;
                }
                const applePayToken = btoa(JSON.stringify(e.payment.token.paymentData));
                try {
                    if (isExpressCheckout && e.payment.shippingContact && e.payment.billingContact) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        const dateOfBirth = getDateOfBirth(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout);
                        const phone = (ref = e.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.shippingContact) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber;
                        const vatId = shippingDetails === null || shippingDetails === void 0 ? void 0 : (ref2 = shippingDetails.expressCheckout) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.formData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customerVatId) === null || ref4 === void 0 ? void 0 : ref4.value;
                        // Only for DK & SE add email optIn to cart as auth0 is not available
                        let selectedOptIns = [];
                        if (changedOptIns) {
                            selectedOptIns = getSelectedOptIns(changedOptIns);
                        }
                        yield setCustomerDetails(swcHelpers.objectSpread({
                            customerDetails: swcHelpers.objectSpread({
                                customerType: Types.CheckoutCustomerType.B2C,
                                email: (ref5 = e.payment.shippingContact) === null || ref5 === void 0 ? void 0 : ref5.emailAddress
                            }, dateOfBirth ? {
                                dateOfBirth
                            } : {}, phone ? {
                                phone
                            } : {}),
                            billingAddress: mapApplePayContactAddress(e.payment.billingContact),
                            shippingAddress: mapShippingAddress(e.payment)
                        }, vatId ? {
                            invoiceDetails: {
                                vatId
                            }
                        } : {}, {
                            marketingEmailsOptIn: selectedOptIns.includes('marketingEmailsOptIn')
                        }));
                    }
                    const createOrderDraftPayload = yield createOrderDraft({
                        paymentDetails: {
                            data: {
                                applePayToken
                            },
                            isValid: true,
                            type: PaymentMethod.APPLE_PAY
                        },
                        selectedPaymentMethod: {
                            type: PaymentMethod.APPLE_PAY,
                            provider: PaymentServiceProvider.ADYEN
                        },
                        returnUrl: 'https://not-needed-but-required-by-adyen.com'
                    });
                    const orderResponse = yield createOrder(createOrderDraftPayload);
                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                    dispatch(resetExpressCheckout());
                    if (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.success) {
                        redirectToOrderComplete({
                            cartId: (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.cartId) || createOrderDraftPayload.checkoutId,
                            orderData: orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.orderDataToken,
                            expressOrder: isExpressCheckout
                        });
                    }
                } catch (e1) {
                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
        session.oncancel = ()=>{
            try {
                session.abort();
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                    throw e;
                }
            }
        };
        session.begin();
    }, [
        error,
        createPaymentRequest,
        createApplePaySession,
        validateShippingData,
        isExpressCheckout,
        validatePaymentData,
        createOrderDraft,
        createOrder,
        dispatch,
        redirectToOrderComplete,
        shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout,
        changedOptIns,
        setCustomerDetails,
        mapShippingAddress, 
    ]);
    return [
        payCartWithApplePay,
        {
            error: error || paymentRequestError || createApplePaySessionError || createOrderError,
            loading: paymentRequestLoading || createApplePaySessionIsLoading || createOrderLoading
        }, 
    ];
};

export { UseApplePayError, useApplePay };
//# sourceMappingURL=use-apple-pay.js.map
